import classes from "./ManageGifList.module.scss";
import { IGif } from "services/types";
import { ManageGifCard } from "./ManageGifCard";
import React, { Fragment, useCallback, useEffect, useState } from "react";
import { EmptyGifLIst } from "./EmptyGifLIst";
import { ManageSelection } from "./ManageSelection";

interface IProps {
  gifs: IGif[];
}

export const ManageGifList = (props: IProps) => {
  const { gifs } = props;

  const [selectedIds, setSelectedIds] = useState<string[]>([]);

  const handleSelect = useCallback((id: string) => {
    setSelectedIds(prevState => {
      const newState = [...prevState];
      const index = prevState.indexOf(id);

      index === -1 ? newState.push(id) : newState.splice(index, 1);

      return newState;
    });
  }, []);

  const handleCloseSelection = useCallback(() => {
    setSelectedIds([]);
  }, []);

  const handleSelectAll = useCallback(() => {
    setSelectedIds(prevState => {
      return prevState.length === gifs.length ? [] : gifs.map(({ id }) => id);
    });
  }, [gifs]);

  const cards = useCallback(() => {
    return gifs.map(
      gif => <ManageGifCard
        key={gif.id}
        gif={gif}
        isSelected={selectedIds.indexOf(gif.id) !== -1}
        onSelect={handleSelect}
      />
    );
  }, [gifs, handleSelect, selectedIds]);

  useEffect(() => {
    handleCloseSelection();
  }, [handleCloseSelection, gifs]);

  return (
    <Fragment>
      {
        gifs.length > 0 ? (
          <Fragment>
            <ManageSelection
              selectedIds={selectedIds}
              gifs={gifs}
              onClose={handleCloseSelection}
              onSelectAll={handleSelectAll}
            />

            <div className={classes.manageGifList}>
              <div className={classes.labelsWrapper}>
                <div className={classes.labels}>
                  <div>Likes</div>
                  <div>Views</div>
                  <div>Visibility</div>
                  <div>Date</div>
                </div>
              </div>
              <div className={classes.list}>
                { cards() }
              </div>
            </div>
          </Fragment>
        ) : (
          <EmptyGifLIst/>
        )
      }
    </Fragment>
  );
};
